import React from 'react';
import { alpha } from '@material-ui/core/styles';
import { Typography, useTheme } from '@material-ui/core';
import { useTranslate } from 'react-admin';
import type { AreaBoundary, RowBoundary, Place, PortBoundary } from '../types/warehouse.types';

interface HoverTooltipProps {
  hoveredPort: PortBoundary | null;
  hoveredArea: AreaBoundary | null;
  hoveredRow: RowBoundary | null;
  hoveredPlace: Place | null;
  mousePosition: { x: number; y: number } | null;
}

export const HoverTooltip: React.FC<HoverTooltipProps> = ({
  hoveredPort,
  hoveredArea,
  hoveredRow,
  hoveredPlace,
  mousePosition
}) => {
  const theme = useTheme();
  const translate = useTranslate();
  if (!mousePosition || (!hoveredArea && !hoveredRow && !hoveredPlace && !hoveredPort)) {
    return null;
  }

  // Priority: Place > Row > Area (most specific to least specific)
  const tooltipContent = hoveredPlace
    ? translate('osfc.storage_ui.tooltip.place', { value: hoveredPlace.label ? `${hoveredPlace.address} • ${hoveredPlace.label}` : hoveredPlace.address })
    : hoveredRow
    ? translate('osfc.storage_ui.tooltip.row', { value: hoveredRow.label ? `${hoveredRow.name} • ${hoveredRow.label}` : hoveredRow.name })
    : hoveredArea
    ? translate('osfc.storage_ui.tooltip.area', { value: hoveredArea.name })
    : hoveredPort
    ? translate('osfc.storage_ui.tooltip.port', { value: hoveredPort.name })
    : null;

  if (!tooltipContent) return null;

  return (
    <Typography
      component="div"
      variant="body2"
      style={{
        position: 'absolute',
        left: mousePosition.x + 15,
        top: mousePosition.y + 15,
        background: alpha(theme.palette.common.black, 0.9),
        color: theme.palette.secondary.main,
        padding: '6px 10px',
        borderRadius: '4px',
        fontSize: '12px',
        border: `1px solid ${theme.palette.secondary.main}`,
        pointerEvents: 'none',
        zIndex: 1000,
        whiteSpace: 'nowrap',
      }}
    >
      {tooltipContent}
    </Typography>
  );
};
